import axios from "../../../config/axiosConfig";

export const getDashboardFacturacion = (params) => axios.get("/api/dashboard-facturacion", { params });
